import { Component, AfterViewInit, ElementRef, ViewChild, ViewEncapsulation, OnInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
//import * as moment from 'moment';
import moment from 'moment';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { HttpHeaders } from '@angular/common/http';
import { FormConfigUtilityService } from '../../services/filterByConfigMetatags/form-config-utility.service';
import { ContentStorageService } from '@ptl/global-components';

@FormComponentLookup('mapped-content')
@Component({
    selector: 'app-mapped-content',
    templateUrl: './mapped-content.component.html',
    styleUrls: ['./mapped-content.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class MappedContentComponent extends FormEntryComponentClass implements AfterViewInit {
  @ViewChild('entryRef') entryRef: ElementRef;
  value: any = [];

  fileContent: string;

  constructor(private commonUtilityService: CommonUtilityService,
    private httpClient: HTTPWrapperContext,
    private formConfigUtility: FormConfigUtilityService,
    private contentStorage: ContentStorageService) {
    super();
  }

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.initTriggers();
    this.getMappedContent();
  }

  async getMappedContent() {

    const strategyMap: Map<string, any> = new Map();
    strategyMap.set("hardcoded", false);
    strategyMap.set("metaTagPriorityByIndex", this.entry.custom.metaTagPriorityByIndex || '');
    strategyMap.set("url", this.entry.custom.fileMapUrl);

    this.contentStorage.storeContentMapFromComponent(this.entry.custom.fileStrategy, strategyMap);

    // Get a formMaps.json for mapped content
    // Filter by Plan type and state selected
    // return the JSONMAP url
    // Join the arrays to make it easier to edit.
    const fileMapUrl = this.entry.custom.formsMapUrl;

    const fileMapConfig = await this.formConfigUtility.getJsonFormConfig(this.entry.custom.fileStrategy) as any;
    const fileFile = await this.getJsonMap(fileMapConfig.url) as any;
    const fileJoined = fileFile.join("");
    this.fileContent = fileJoined;
  }

  getJsonMap(url: string) {

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: url,
      headers: new HttpHeaders({})
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.MOCK);
    return this.httpClient.makeRequest(requestConfig);

  }

}
